import { useAccommodationOffers } from "~/applications/OfferSearch/Api/useAccommodationOffers";
import { useHotelPagesOfDestination } from "~/applications/OfferSearch/Api/useHotelPagesOfDestination";
import { useUnitGroupsOfHotels } from "~/applications/OfferSearch/Api/useUnitGroupsOfHotels";
import { Offer } from "~/applications/OfferSearch/Domain/Offer";
import StayRequest from "~/core/StayRequest";
import { AVAILABLE_LOCALES } from "~/core/locale";
import { CancellationPolicyId } from "../Domain/CancellationPolicyId";

export const useOffers = (
  destinationId: string,
  stayRequest: StayRequest,
  locale: AVAILABLE_LOCALES,
  cancellationPolicyId: CancellationPolicyId,
): Array<Offer> | undefined => {
  const { hotelPages } = useHotelPagesOfDestination({
    destinationId,
    locale,
  });

  const { accommodationOffers } = useAccommodationOffers(
    hotelPages !== null
      ? {
          logePmsIds: hotelPages.map((oneHotelPage) => oneHotelPage.loge.pmsId),
          checkIn: stayRequest.checkIn,
          checkOut: stayRequest.checkOut,
          nbAdult: stayRequest.nbAdult,
          nbChildren: stayRequest.nbChildren,
          nbBabies: stayRequest.nbBabies,
          promoCode: stayRequest.promoCode,
          cancellationPolicyId: cancellationPolicyId,
        }
      : false,
  );

  const { unitGroups } = useUnitGroupsOfHotels(
    hotelPages !== null
      ? {
          locale,
          hotelIds: hotelPages.map(
            (oneHotelPage) => oneHotelPage.loge.sanityId,
          ),
        }
      : false,
  );

  if (!accommodationOffers || !unitGroups) {
    return undefined;
  }

  const offers: Array<Offer> = [];

  accommodationOffers.forEach((oneAccommodationOffer) => {
    const oneUnitGroup = unitGroups.find(
      (unitGroup) => unitGroup.id === oneAccommodationOffer.unitGroupId,
    );

    if (oneUnitGroup === undefined) {
      console.warn(
        `No unit group found with id "${oneAccommodationOffer.unitGroupId}". Ignoring the accommodation offer.`,
      );
      return;
    }

    offers.push(new Offer(oneAccommodationOffer, oneUnitGroup));
  });

  return offers;
};
